export const ru = {
    'placeholder.suggest_kontur': 'Введите ИНН или название компании',
};
